import {
	AccessorFnColumnDef,
	AccessorKeyColumnDef,
} from '@tanstack/react-table'
import { useContext } from 'react'

import { TQrData } from '@/generator/shared'

import { rowContext } from '../tableState'
import { TRow } from '../tableTypes'

export const getCellValue = <T>(
	row: TRow,
	colDef: AccessorKeyColumnDef<TQrData, T> | AccessorFnColumnDef<TQrData, T>,
) => {
	const cell = row
		.getVisibleCells()
		.find((cell) => cell.column.id === colDef.id)
	return cell?.getValue() as T
}

export const useCellValue = <T>(
	colDef: AccessorKeyColumnDef<TQrData, T> | AccessorFnColumnDef<TQrData, T>,
) => {
	const row = useContext(rowContext)

	return getCellValue(row, colDef)
}
